// extracted by mini-css-extract-plugin
export default {"wrapper":"ResponseTime_wrapper__Ks2Y7","icon":"ResponseTime_icon__H+mIS","title":"ResponseTime_title__ZlAKd","bigNumber":"ResponseTime_bigNumber__q3enG"};